import { render, staticRenderFns } from "./BandeiraHipercard.vue?vue&type=template&id=24834efe&"
import script from "./BandeiraHipercard.vue?vue&type=script&lang=js&"
export * from "./BandeiraHipercard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports